import { observable } from "@legendapp/state";
import type * as Ably from "ably";

import { getOrgChannel } from "~/libs/pubsub.lib";
import { trpc } from "~/libs/trpc.lib";
import { syncedCrudPersist } from "../../libs/legend-state";
import { orgReady$ } from "../app-data-ready";
import type { Datasource } from "./datasources.types";

export const datasources$ = observable(
  syncedCrudPersist<Datasource>({
    persist: {
      name: "datasources",
    },
    waitFor: orgReady$,
    list: async () => {
      return await trpc.datasources.list.query();
    },
    update: async ({ id, ...input }) => {
      if (!id) return;

      return await trpc.datasources.update.mutate({
        id,
        ...input,
      });
    },
    delete: async (input) => {
      if (!input.id) return;

      await trpc.datasources.delete.mutate({
        datasourceId: input.id,
      });
    },
    subscribe: ({ update }) => {
      const channel = getOrgChannel();
      if (!channel) return;

      const handler = (message: Ably.Message) => {
        update({
          mode: "merge",
          value: Array.isArray(message.data) ? message.data : [message.data],
        });
      };

      channel.subscribe("datasources", handler);

      return () => {
        channel.unsubscribe("datasources", handler);
      };
    },
  }),
);
